import(/* webpackMode: "eager" */ "/vercel/path1/app/leaderboard/[examType]/page.tsx");
